import Config from "./config/config";
import Locale from "./config/locale";

export default {
  modules: {
    authentication: {
      strict: true,
      namespaced: true,
      state: {
			authToken: Config.getCookie("auth") != "" ? Config.getCookie("auth") : null,
      checked: false,
      loggedIn: false,
      user_hash: "",
      user_name: "",
      },
      mutations: {
        login (state, data) {
          state.loggedIn = true
        }
      }
    },
    l: {
      strict: true,
      namespaced: true,
      state: {
        lang: parseInt(Config.getCookie("lang")) === 0 ? 0 : 1
      },
      mutations: {
        ts (state, data) {
          state.loggedIn = true
        }
      }
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/store.js